// extracted by mini-css-extract-plugin
export default {"container":"container__gLe6aY5c","fadeout":"fadeout__Ey9quPuL"};